// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container__QWThl","loaderIcon":"LoadingScreen_loaderIcon__JL3fh","mobile":"LoadingScreen_mobile__tRBAh","tablet":"LoadingScreen_tablet__XZYMZ"};